const LanguageNode = () => {
  return "LanguageNode";
};
export default LanguageNode;